// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13WQI","buttons":"Footer_buttons__2I1jf"};